import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { ALL_URL, isParalympic } from 'helpers/utils';
import { FilterEventTypes, createEventData, pagesWithRecordFilter, publishFilterEvent } from 'components/common/ocs-custom-events/filterEvents';




export default function SelectorRecord({ page = "", recordsList, useRecordsList = false, onSelectRecord, selectedRecord }) {
    let params = useUrlFriendlyToParameters()
    const [records, setRecords] = useState([]);
    //copy parameters URL to change 
    let paramsURL = { ...params }
    useEffect(() => {
        const allRecordsOfDiscipline = process.env[(isParalympic(paramsURL['mirs_competition']) ? 'REACT_APP_RECORDS_PARAS_' : 'REACT_APP_RECORDS_') + paramsURL.mirs_discipline]?.split(',') || [];
        let tempRecords = [];
        if (useRecordsList && Array.isArray(recordsList)) {
            tempRecords = recordsList?.filter(item => allRecordsOfDiscipline?.includes(item?.code));

        } else {
            tempRecords = allRecordsOfDiscipline;
        };

        setRecords(tempRecords);
    }, [recordsList, useRecordsList, paramsURL['mirs_competition'], paramsURL['mirs_discipline']]);


    //Go to schedule 
    const handleOnChange = (key) => {
        if (pagesWithRecordFilter.includes(page)) {
            const payload = createEventData(FilterEventTypes.RECORD, key);
            publishFilterEvent(payload);
        }
        onSelectRecord(key);
    };

    return (
        <Dropdown onSelect={handleOnChange} className={"selectorContainer"} >
            <Dropdown.Toggle variant="success" id="selectorRecords">
                {selectedRecord && selectedRecord !== ALL_URL.ALL_RECORD ? records?.find(r => r?.code === selectedRecord)?.description : <Label data={'LabelRecords'} />}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item key="Selector-Record-all" eventKey={ALL_URL.ALL_RECORD} >
                    <Label data={'LabelAllRecords'} />
                </Dropdown.Item>
                {records.map(record => <Dropdown.Item key={`Selector-Record-${record.code}`} eventKey={record.code} >
                    {record.description}
                </Dropdown.Item>)}
            </Dropdown.Menu>
        </Dropdown>
    );
}